<template>
    <div class="flex flex-col h-screen-index">
        <!-- 头部导航 -->
        <div class="flex items-center justify-between p-4">
            <div class="flex items-center space-x-4">
                <div class="tabs tabs-boxed">
                    <a :class="{ 'tab': true, 'tab-active': activeTab === 'tagSource' }" @click="activeTab = 'tagSource'">
                        <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 7h.01M7 3h5c.512 0 1.024.195 1.414.586l7 7a2 2 0 010 2.828l-7 7a2 2 0 01-2.828 0l-7-7A1.994 1.994 0 013 12V7a4 4 0 014-4z" />
                        </svg>
                        <div class="hidden md:block">
                            标签源插件
                        </div>
                    </a>
                    <a :class="{ 'tab': true, 'tab-active': activeTab === 'action' }" @click="activeTab = 'action'">
                        <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                        </svg>
                        <div class="hidden md:block">
                            操作台插件
                        </div>
                    </a>
                </div>
            </div>
            <div class="flex items-center space-x-2">
                <button class="btn btn-primary btn-sm" @click="refreshPlugins">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
                    </svg>
                    刷新
                </button>
                <button class="btn btn-outline btn-sm" @click="showUploadDrawer = true">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
                    </svg>
                    添加插件
                </button>
            </div>
        </div>

        <!-- 主要内容区域 -->
        <div class="flex flex-1 overflow-hidden">
            <!-- 左侧内容 -->
            <div class="flex-1 flex flex-col">
                <!-- 标签源插件列表 -->
                <div v-show="activeTab === 'tagSource'" class="p-4 overflow-y-auto flex-1">
                    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
                        <div v-for="(plugin, index) in tagSourceScripts" :key="plugin.id" class="card bg-base-100 shadow-xl hover:shadow-2xl transition-shadow">
                            <div class="card-body p-4">
                                <div class="flex items-start justify-between">
                                    <div class="flex-1">
                                        <h3 class="card-title text-lg">{{ plugin.name }}</h3>
                                        <div class="flex items-center space-x-2 mt-1">
                                            <div class="badge badge-primary badge-sm">v{{ plugin.version }}</div>
                                            <div :class="['badge', 'badge-sm','text-white',  plugin.state === 'online' ? 'badge-success' : 'badge-warning']">
                                                {{ plugin.state === 'online' ? '在线' : '离线' }}
                                            </div>
                                        </div>
                                    </div>
                                    <div class="dropdown dropdown-end">
                                        <label tabindex="0" class="btn btn-ghost btn-sm btn-circle">
                                            <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 5v.01M12 12v.01M12 19v.01" />
                                            </svg>
                                        </label>
                                        <ul tabindex="0" class="dropdown-content menu p-2 shadow bg-base-100 rounded-box w-32">
                                            <li><a @click="openPluginSettings(plugin, 'tagSource')">设置</a></li>
                                            <li><a @click="togglePluginState(plugin, 'tagSource')">{{ plugin.state === 'online' ? '禁用' : '启用' }}</a></li>
                                            <li><a @click="deletePlugin(plugin, 'tagSource')" class="text-error">删除</a></li>
                                        </ul>
                                    </div>
                                </div>
                                <p class="text-sm text-base-content/70 mt-2 line-clamp-2">{{ plugin.description }}</p>
                                <div class="card-actions justify-end mt-4">
                                    <button class="btn btn-primary btn-sm" @click="configurePlugin(plugin, 'tagSource')">
                                        配置
                                    </button>
                                    <button v-if="plugin.state === 'online'" class="btn btn-outline btn-sm" @click="testPlugin(plugin, 'tagSource')">
                                        测试
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-if="tagSourceScripts.length === 0" class="text-center py-12">
                        <svg xmlns="http://www.w3.org/2000/svg" class="h-16 w-16 mx-auto text-base-content/30" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 7h.01M7 3h5c.512 0 1.024.195 1.414.586l7 7a2 2 0 010 2.828l-7 7a2 2 0 01-2.828 0l-7-7A1.994 1.994 0 013 12V7a4 4 0 014-4z" />
                        </svg>
                        <h3 class="text-lg font-medium text-base-content/70 mt-4">暂无标签源插件</h3>
                        <p class="text-base-content/50 mt-2">点击"添加插件"按钮来添加您的第一个标签源插件</p>
                    </div>
                </div>

                <!-- 操作台插件列表 -->
                <div v-show="activeTab === 'action'" class="p-4 overflow-y-auto flex-1">
                    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
                        <div v-for="(plugin, index) in actionScripts" :key="plugin.id" class="card bg-base-100 shadow-xl hover:shadow-2xl transition-shadow">
                            <div class="card-body p-4">
                                <div class="flex items-start justify-between">
                                    <div class="flex-1">
                                        <h3 class="card-title text-lg">{{ plugin.name }}</h3>
                                        <div class="flex items-center space-x-2 mt-1">
                                            <div class="badge badge-primary badge-sm">v{{ plugin.version }}</div>
                                            <div :class="['badge', 'badge-sm','text-white', plugin.state === 'online' ? 'badge-success' : 'badge-warning']">
                                                {{ plugin.state === 'online' ? '在线' : '离线' }}
                                            </div>
                                        </div>
                                    </div>
                                    <div class="dropdown dropdown-end">
                                        <label tabindex="0" class="btn btn-ghost btn-sm btn-circle">
                                            <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 5v.01M12 12v.01M12 19v.01" />
                                            </svg>
                                        </label>
                                        <ul tabindex="0" class="dropdown-content menu p-2 shadow bg-base-100 rounded-box w-32">
                                            <li><a @click="openPluginSettings(plugin, 'action')">设置</a></li>
                                            <li><a @click="togglePluginState(plugin, 'action')">{{ plugin.state === 'online' ? '禁用' : '启用' }}</a></li>
                                            <li><a @click="deletePlugin(plugin, 'action')" class="text-error">删除</a></li>
                                        </ul>
                                    </div>
                                </div>
                                <p class="text-sm text-base-content/70 mt-2 line-clamp-2">{{ plugin.description }}</p>
                                <div class="card-actions justify-end mt-4">
                                    <button class="btn btn-primary btn-sm" @click="configurePlugin(plugin, 'action')">
                                        配置
                                    </button>
                                    <button v-if="plugin.state === 'online'" class="btn btn-outline btn-sm" @click="executePlugin(plugin)">
                                        执行
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-if="actionScripts.length === 0" class="text-center py-12">
                        <svg xmlns="http://www.w3.org/2000/svg" class="h-16 w-16 mx-auto text-base-content/30" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                        </svg>
                        <h3 class="text-lg font-medium text-base-content/70 mt-4">暂无操作台插件</h3>
                        <p class="text-base-content/50 mt-2">点击"添加插件"按钮来添加您的第一个操作台插件</p>
                    </div>
                </div>
            </div>
        </div>

        <!-- 上传插件抽屉 -->
        <div class="drawer drawer-end">
            <input id="upload-drawer" type="checkbox" class="drawer-toggle" v-model="showUploadDrawer" />
            <div class="drawer-side">
                <label for="upload-drawer" aria-label="close sidebar" class="drawer-overlay"></label>
                <div class="p-4 min-h-full bg-base-100 text-base-content w-96">
                    <div class="flex justify-between items-center mb-6">
                        <h2 class="text-xl font-bold">添加插件</h2>
                        <button class="btn btn-sm btn-circle btn-ghost" @click="showUploadDrawer = false">
                            <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                            </svg>
                        </button>
                    </div>

                    <div class="form-control mb-4">
                        <label class="label">
                            <span class="label-text">插件类型</span>
                        </label>
                        <select class="select select-bordered" v-model="uploadForm.type">
                            <option value="tagSource">标签源插件</option>
                            <option value="action">操作台插件</option>
                        </select>
                    </div>

                    <div class="form-control mb-4">
                        <label class="label">
                            <span class="label-text">插件名称</span>
                        </label>
                        <input type="text" class="input input-bordered" v-model="uploadForm.name" placeholder="输入插件名称" />
                    </div>

                    <div class="form-control mb-4">
                        <label class="label">
                            <span class="label-text">唯一标识</span>
                        </label>
                        <input type="text" class="input input-bordered" v-model="uploadForm.unique_id" placeholder="输入唯一标识" />
                    </div>

                    <div class="form-control mb-4">
                        <label class="label">
                            <span class="label-text">版本号</span>
                        </label>
                        <input type="text" class="input input-bordered" v-model="uploadForm.version" placeholder="1.0.0" />
                    </div>

                    <div class="form-control mb-4">
                        <label class="label">
                            <span class="label-text">插件描述</span>
                        </label>
                        <textarea class="textarea textarea-bordered" v-model="uploadForm.description" placeholder="输入插件描述"></textarea>
                    </div>

                    <!-- 代码输入方式选择 -->
                    <div class="form-control mb-4">
                        <label class="label">
                            <span class="label-text">代码输入方式</span>
                        </label>
                        <div class="tabs tabs-boxed">
                            <a :class="{ 'tab': true, 'tab-active': codeInputMode === 'text' }" @click="codeInputMode = 'text'">
                                <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                                </svg>
                                手动输入
                            </a>
                            <a :class="{ 'tab': true, 'tab-active': codeInputMode === 'file' }" @click="codeInputMode = 'file'">
                                <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12" />
                                </svg>
                                文件上传
                            </a>
                        </div>
                        
                        <!-- 示例模板下载 -->
                        <div class="flex justify-end mt-2">
                            <div class="dropdown dropdown-end">
                                <label tabindex="0" class="btn btn-ghost btn-xs">
                                    <svg xmlns="http://www.w3.org/2000/svg" class="h-3 w-3 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                                    </svg>
                                    下载模板
                                </label>
                                <ul tabindex="0" class="dropdown-content menu p-2 shadow bg-base-100 rounded-box w-40">
                                    <li><a @click="downloadTemplate('tagSource', 'py')">标签源插件 (.py)</a></li>
                                    <li><a @click="downloadTemplate('action', 'py')">操作台插件 (.py)</a></li>
                                    <li><a @click="downloadTemplate('tagSource', 'js')">标签源插件 (.js)</a></li>
                                    <li><a @click="downloadTemplate('action', 'js')">操作台插件 (.js)</a></li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    <!-- 手动输入代码 -->
                    <div v-if="codeInputMode === 'text'" class="form-control mb-6">
                        <label class="label">
                            <span class="label-text">插件代码</span>
                        </label>
                        <textarea class="textarea textarea-bordered h-32 font-mono text-sm" v-model="uploadForm.content" placeholder="输入插件代码"></textarea>
                    </div>

                    <!-- 文件上传区域 -->
                    <div v-if="codeInputMode === 'file'" class="form-control mb-6">
                        <label class="label">
                            <span class="label-text">上传代码文件</span>
                            <span class="label-text-alt">支持 .py, .js, .ts 等格式</span>
                        </label>
                        
                        <!-- 文件拖拽上传区域 -->
                        <div 
                            class="border-2 border-dashed border-base-300 rounded-lg p-6 text-center transition-colors"
                            :class="{ 'border-primary bg-primary/10': isDragOver }"
                            @dragover.prevent="handleDragOver"
                            @dragleave.prevent="handleDragLeave"
                            @drop.prevent="handleFileDrop"
                        >
                            <input 
                                type="file" 
                                ref="fileInput" 
                                class="hidden" 
                                accept=".py,.js,.ts,.txt,.md"
                                @change="handleFileSelect"
                            />
                            
                            <div v-if="!uploadedFile">
                                <svg xmlns="http://www.w3.org/2000/svg" class="h-12 w-12 mx-auto text-base-content/30 mb-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12" />
                                </svg>
                                <p class="text-base-content/70 mb-2">拖拽文件到这里或</p>
                                <button type="button" class="btn btn-outline btn-sm" @click="$refs.fileInput.click()">
                                    选择文件
                                </button>
                            </div>
                            
                            <!-- 已上传文件信息 -->
                            <div v-else class="text-left">
                                <div class="flex items-center justify-between p-3 bg-base-200 rounded-lg">
                                    <div class="flex items-center space-x-3">
                                        <div class="avatar placeholder">
                                            <div class="bg-primary text-primary-content rounded w-10 h-10">
                                                <span class="text-xs">{{ getFileIcon(uploadedFile.name) }}</span>
                                            </div>
                                        </div>
                                        <div>
                                            <div class="font-medium">{{ uploadedFile.name }}</div>
                                            <div class="text-sm text-base-content/70">{{ formatFileSize(uploadedFile.size) }}</div>
                                        </div>
                                    </div>
                                    <div class="flex items-center space-x-2">
                                        <div class="badge badge-success badge-sm">已上传</div>
                                        <button type="button" class="btn btn-ghost btn-xs btn-circle" @click="removeFile">
                                            <svg xmlns="http://www.w3.org/2000/svg" class="h-3 w-3" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                                            </svg>
                                        </button>
                                    </div>
                                </div>
                                
                                <!-- 文件内容预览 -->
                                <div class="mt-4">
                                    <div class="collapse collapse-arrow bg-base-200">
                                        <input type="checkbox" />
                                        <div class="collapse-title text-sm font-medium">
                                            代码预览 ({{ uploadForm.content.length }} 字符)
                                        </div>
                                        <div class="collapse-content">
                                            <textarea 
                                                class="textarea textarea-bordered w-full h-32 font-mono text-xs" 
                                                v-model="uploadForm.content" 
                                                readonly
                                            ></textarea>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                        <!-- 文件验证错误信息 -->
                        <div v-if="fileError" class="alert alert-error mt-2">
                            <svg xmlns="http://www.w3.org/2000/svg" class="stroke-current shrink-0 h-6 w-6" fill="none" viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z" />
                            </svg>
                            <span>{{ fileError }}</span>
                        </div>
                    </div>

                    <div class="flex justify-end space-x-2">
                        <button class="btn btn-outline" @click="resetUploadForm">重置</button>
                        <button class="btn btn-primary" @click="uploadPlugin" :disabled="!canUpload">
                            <span class="loading loading-spinner loading-sm" v-if="uploading"></span>
                            上传
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <!-- 插件配置抽屉 -->
        <PluginConfigDrawer 
            :plugin="currentPlugin"
            :plugin-type="currentPluginType"
            :show="showConfigDrawer"
            @update:show="showConfigDrawer = $event"
            @config-updated="handleConfigUpdated"
        />
    </div>
</template>

<script>
import PluginConfigDrawer from '@/components/mod/PluginConfigDrawer.vue'
export default {
    name: 'PluginManager',
    components: {
        PluginConfigDrawer,
    },
    data() {
        return {
            activeTab: 'tagSource',
            tagSourceScripts: [],
            actionScripts: [],
            showUploadDrawer: false,
            showConfigDrawer: false,
            uploading: false,
            currentPlugin: null,
            currentPluginType: null,
            uploadForm: {
                type: 'tagSource',
                name: '',
                unique_id: '',
                version: '1.0.0',
                description: '',
                content: ''
            },
            codeInputMode: 'text',
            isDragOver: false,
            uploadedFile: null,
            fileError: null
        }
    },
    computed: {
        canUpload() {
            const hasBasicInfo = this.uploadForm.name && this.uploadForm.unique_id && !this.uploading
            
            if (this.codeInputMode === 'text') {
                return hasBasicInfo && this.uploadForm.content
            } else {
                return hasBasicInfo && this.uploadedFile && this.uploadForm.content && !this.fileError
            }
        },
    },
    created() {
        this.fetchPlugins()
    },
    methods: {
        async fetchPlugins() {
            try {
                // 获取标签源插件
                const tagResponse = await this.$api.Task.getResourceScript({ page_size: 100 })
                if (tagResponse.result) {
                    this.tagSourceScripts = tagResponse.data.items || []
                }

                // 获取操作台插件
                const actionResponse = await this.$api.Task.getActionScript({ page_size: 100 })
                if (actionResponse.result) {
                    this.actionScripts = actionResponse.data.items || []
                }
            } catch (error) {
                this.$myMsg.notify({
                    title: '获取插件列表失败',
                    message: error.message,
                    type: 'error',
                    time: 3000
                })
            }
        },
        
        refreshPlugins() {
            this.fetchPlugins()
            this.$myMsg.notify({
                title: '刷新成功',
                type: 'success',
                time: 2000
            })
        },

        configurePlugin(plugin, type) {
            this.currentPlugin = plugin
            this.currentPluginType = type
            this.showConfigDrawer = true
        },

        openPluginSettings(plugin, type) {
            this.configurePlugin(plugin, type)
        },

        handleConfigUpdated(data) {
            // 处理插件配置更新
            const { plugin, config, enabled } = data
            
            // 更新插件状态
            plugin.state = enabled ? 'online' : 'offline'
            plugin.config = config
            
            this.$myMsg.notify({
                title: '插件配置已更新',
                type: 'success',
                time: 2000
            })
            
            this.fetchPlugins()
        },

        async togglePluginState(plugin, type) {
            try {
                // 这里应该调用切换插件状态的API
                plugin.state = plugin.state === 'online' ? 'offline' : 'online'
                this.$myMsg.notify({
                    title: `插件${plugin.state === 'online' ? '启用' : '禁用'}成功`,
                    type: 'success',
                    time: 2000
                })
            } catch (error) {
                this.$myMsg.notify({
                    title: '操作失败',
                    message: error.message,
                    type: 'error',
                    time: 3000
                })
            }
        },

        async deletePlugin(plugin, type) {
            if (!confirm(`确定要删除插件"${plugin.name}"吗？`)) {
                return
            }

            try {
                // 这里应该调用删除插件的API
                if (type === 'tagSource') {
                    this.tagSourceScripts = this.tagSourceScripts.filter(p => p.id !== plugin.id)
                } else {
                    this.actionScripts = this.actionScripts.filter(p => p.id !== plugin.id)
                }
                this.$myMsg.notify({
                    title: '插件删除成功',
                    type: 'success',
                    time: 2000
                })
            } catch (error) {
                this.$myMsg.notify({
                    title: '删除失败',
                    message: error.message,
                    type: 'error',
                    time: 3000
                })
            }
        },

        async testPlugin(plugin, type) {
            try {
                this.$myMsg.notify({
                    title: '测试插件中...',
                    type: 'info',
                    time: 2000
                })
                // 这里应该调用测试插件的API
            } catch (error) {
                this.$myMsg.notify({
                    title: '测试失败',
                    message: error.message,
                    type: 'error',
                    time: 3000
                })
            }
        },

        async executePlugin(plugin) {
            try {
                this.$myMsg.notify({
                    title: '执行插件中...',
                    type: 'info',
                    time: 2000
                })
                // 这里应该调用执行插件的API
                // 对于操作台插件，跳转到具体的操作页面
                this.$router.push({ name: 'actionMod', params: { id: plugin.id } })
            } catch (error) {
                this.$myMsg.notify({
                    title: '执行失败',
                    message: error.message,
                    type: 'error',
                    time: 3000
                })
            }
        },

        async uploadPlugin() {
            if (!this.canUpload) return

            this.uploading = true
            try {
                // 这里需要根据实际的API接口调用
                this.$myMsg.notify({
                    title: '插件上传成功',
                    type: 'success',
                    time: 2000
                })
                
                this.resetUploadForm()
                this.showUploadDrawer = false
                this.fetchPlugins()
            } catch (error) {
                this.$myMsg.notify({
                    title: '上传失败',
                    message: error.message,
                    type: 'error',
                    time: 3000
                })
            } finally {
                this.uploading = false
            }
        },

        resetUploadForm() {
            this.uploadForm = {
                type: 'tagSource',
                name: '',
                unique_id: '',
                version: '1.0.0',
                description: '',
                content: ''
            }
            this.codeInputMode = 'text'
            this.uploadedFile = null
            this.fileError = null
            if (this.$refs.fileInput) {
                this.$refs.fileInput.value = ''
            }
        },

        handleDragOver(event) {
            event.preventDefault()
            this.isDragOver = true
        },

        handleDragLeave(event) {
            event.preventDefault()
            this.isDragOver = false
        },

        handleFileDrop(event) {
            event.preventDefault()
            this.isDragOver = false
            const files = event.dataTransfer.files
            if (files.length > 0) {
                this.processFile(files[0])
            }
        },

        handleFileSelect(event) {
            const files = event.target.files
            if (files.length > 0) {
                this.processFile(files[0])
            }
        },

        async processFile(file) {
            this.fileError = null
            
            // 文件类型验证
            const allowedExtensions = ['py', 'js', 'ts', 'txt', 'md']
            const fileExtension = file.name.split('.').pop().toLowerCase()
            
            if (!allowedExtensions.includes(fileExtension)) {
                this.fileError = `不支持的文件类型：${fileExtension}。支持的格式：${allowedExtensions.join(', ')}`
                return
            }

            // 文件大小验证（限制为1MB）
            const maxSize = 1024 * 1024 // 1MB
            if (file.size > maxSize) {
                this.fileError = `文件过大：${this.formatFileSize(file.size)}。最大允许：${this.formatFileSize(maxSize)}`
                return
            }

            this.uploadedFile = file

            try {
                // 读取文件内容
                const content = await this.readFileContent(file)
                this.uploadForm.content = content

                // 尝试从文件内容中提取插件信息
                this.extractPluginInfo(content, file.name)

                this.$myMsg.notify({
                    title: '文件上传成功',
                    message: `已读取 ${this.formatFileSize(file.size)} 的代码内容`,
                    type: 'success',
                    time: 2000
                })

            } catch (error) {
                this.fileError = `读取文件失败：${error.message}`
                this.uploadedFile = null
            }
        },

        readFileContent(file) {
            return new Promise((resolve, reject) => {
                const reader = new FileReader()
                
                reader.onload = (event) => {
                    try {
                        const content = event.target.result
                        // 验证文件内容是否为文本
                        if (typeof content === 'string') {
                            resolve(content)
                        } else {
                            reject(new Error('文件不是有效的文本格式'))
                        }
                    } catch (error) {
                        reject(error)
                    }
                }
                
                reader.onerror = () => {
                    reject(new Error('文件读取失败'))
                }
                
                reader.readAsText(file, 'UTF-8')
            })
        },

        extractPluginInfo(content, fileName) {
            // 从文件名提取插件标识
            if (!this.uploadForm.unique_id) {
                const baseName = fileName.split('.')[0]
                this.uploadForm.unique_id = baseName.toLowerCase().replace(/[^a-z0-9_]/g, '_')
            }

            // 尝试从代码注释中提取插件信息
            const lines = content.split('\n')
            
            for (let line of lines.slice(0, 20)) { // 只检查前20行
                line = line.trim()
                
                // Python风格注释
                if (line.startsWith('#') || line.startsWith('"""') || line.startsWith("'''")) {
                    this.parseCommentLine(line)
                }
                
                // JavaScript风格注释
                if (line.startsWith('//') || line.startsWith('/*') || line.startsWith('*')) {
                    this.parseCommentLine(line)
                }
            }

            // 如果没有提取到名称，使用文件名
            if (!this.uploadForm.name) {
                this.uploadForm.name = fileName.split('.')[0].replace(/[_-]/g, ' ')
            }
        },

        parseCommentLine(line) {
            // 移除注释符号
            const cleanLine = line.replace(/^[#\/\*"'\s]+/, '').replace(/["\*\/\s]+$/, '').trim()
            
            // 解析常见的元数据格式
            if (cleanLine.match(/^name:\s*(.+)/i)) {
                const name = cleanLine.match(/^name:\s*(.+)/i)[1].trim()
                if (!this.uploadForm.name) this.uploadForm.name = name
            }
            
            if (cleanLine.match(/^version:\s*(.+)/i)) {
                const version = cleanLine.match(/^version:\s*(.+)/i)[1].trim()
                this.uploadForm.version = version
            }
            
            if (cleanLine.match(/^description:\s*(.+)/i)) {
                const description = cleanLine.match(/^description:\s*(.+)/i)[1].trim()
                if (!this.uploadForm.description) this.uploadForm.description = description
            }
            
            if (cleanLine.match(/^id:\s*(.+)/i)) {
                const id = cleanLine.match(/^id:\s*(.+)/i)[1].trim()
                if (!this.uploadForm.unique_id) this.uploadForm.unique_id = id
            }
            
            if (cleanLine.match(/^type:\s*(.+)/i)) {
                const type = cleanLine.match(/^type:\s*(.+)/i)[1].trim().toLowerCase()
                if (type.includes('tag') || type.includes('source')) {
                    this.uploadForm.type = 'tagSource'
                } else if (type.includes('action') || type.includes('operation')) {
                    this.uploadForm.type = 'action'
                }
            }
        },

        removeFile() {
            this.uploadedFile = null
            this.uploadForm.content = ''
            this.fileError = null
            if (this.$refs.fileInput) {
                this.$refs.fileInput.value = ''
            }
        },

        getFileIcon(fileName) {
            const extension = fileName.split('.').pop().toLowerCase()
            switch (extension) {
                case 'py':
                    return '🐍'
                case 'js':
                    return '🟨'
                case 'ts':
                    return '🔷'
                case 'txt':
                    return '📄'
                case 'md':
                    return '📝'
                default:
                    return '📄'
            }
        },

        formatFileSize(size) {
            if (size < 1024) {
                return size + ' B'
            } else if (size < 1024 * 1024) {
                return (size / 1024).toFixed(2) + ' KB'
            } else if (size < 1024 * 1024 * 1024) {
                return (size / (1024 * 1024)).toFixed(2) + ' MB'
            } else {
                return (size / (1024 * 1024 * 1024)).toFixed(2) + ' GB'
            }
        },

        downloadTemplate(type, extension) {
            const templates = {
                'tagSource-py': {
                    name: 'tag_source_plugin_template',
                    content: `#!/usr/bin/env python3
# -*- coding: utf-8 -*-
"""
Name: 标签源插件模板
Description: 这是一个标签源插件的模板文件
Version: 1.0.0
Type: tagSource
ID: tag_source_template
Author: Your Name
"""

class TagSourcePlugin:
    """标签源插件基类"""
    
    def __init__(self):
        self.name = "标签源插件模板"
        self.version = "1.0.0"
        self.description = "这是一个标签源插件的模板"
        
    def search(self, query):
        """
        搜索音乐标签信息
        
        Args:
            query (dict): 搜索查询参数
                - title: 歌曲标题
                - artist: 艺术家
                - album: 专辑名
                
        Returns:
            list: 搜索结果列表
        """
        # 实现你的搜索逻辑
        results = []
        
        # 示例返回格式
        result = {
            'title': query.get('title', ''),
            'artist': query.get('artist', ''),
            'album': query.get('album', ''),
            'year': None,
            'genre': None,
            'track_number': None,
            'disc_number': None,
            'lyrics': None,
            'cover_url': None,
            'confidence': 0.0  # 匹配置信度 0-1
        }
        
        results.append(result)
        return results
        
    def get_lyrics(self, title, artist):
        """
        获取歌词
        
        Args:
            title (str): 歌曲标题
            artist (str): 艺术家
            
        Returns:
            str: 歌词内容
        """
        # 实现歌词获取逻辑
        return None
        
    def get_cover(self, title, artist, album):
        """
        获取专辑封面
        
        Args:
            title (str): 歌曲标题
            artist (str): 艺术家
            album (str): 专辑名
            
        Returns:
            str: 封面图片URL
        """
        # 实现封面获取逻辑
        return None

# 插件入口函数
def main():
    return TagSourcePlugin()
`
                },
                'action-py': {
                    name: 'action_plugin_template',
                    content: `#!/usr/bin/env python3
# -*- coding: utf-8 -*-
"""
Name: 操作台插件模板
Description: 这是一个操作台插件的模板文件
Version: 1.0.0
Type: action
ID: action_template
Author: Your Name
"""

import os
import sys

class ActionPlugin:
    """操作台插件基类"""
    
    def __init__(self):
        self.name = "操作台插件模板"
        self.version = "1.0.0"
        self.description = "这是一个操作台插件的模板"
        
    def execute(self, files, options=None):
        """
        执行插件操作
        
        Args:
            files (list): 要处理的文件列表
            options (dict): 插件选项参数
            
        Returns:
            dict: 执行结果
                - success: 是否成功
                - message: 结果消息
                - processed: 处理的文件数量
                - errors: 错误列表
        """
        if options is None:
            options = {}
            
        processed = 0
        errors = []
        
        try:
            for file_path in files:
                if os.path.exists(file_path):
                    # 实现你的文件处理逻辑
                    result = self.process_file(file_path, options)
                    if result:
                        processed += 1
                    else:
                        errors.append(f"处理文件失败: {file_path}")
                else:
                    errors.append(f"文件不存在: {file_path}")
                    
            return {
                'success': len(errors) == 0,
                'message': f"处理完成，成功: {processed}, 失败: {len(errors)}",
                'processed': processed,
                'errors': errors
            }
            
        except Exception as e:
            return {
                'success': False,
                'message': f"执行失败: {str(e)}",
                'processed': processed,
                'errors': errors + [str(e)]
            }
            
    def process_file(self, file_path, options):
        """
        处理单个文件
        
        Args:
            file_path (str): 文件路径
            options (dict): 处理选项
            
        Returns:
            bool: 是否处理成功
        """
        try:
            # 实现你的文件处理逻辑
            print(f"处理文件: {file_path}")
            
            # 示例：重命名文件
            if options.get('rename', False):
                new_name = options.get('new_name', 'new_file')
                # 重命名逻辑
                pass
                
            # 示例：修改文件元数据
            if options.get('update_metadata', False):
                # 元数据修改逻辑
                pass
                
            return True
            
        except Exception as e:
            print(f"处理文件失败: {file_path}, 错误: {str(e)}")
            return False
            
    def validate_options(self, options):
        """
        验证插件选项
        
        Args:
            options (dict): 选项参数
            
        Returns:
            tuple: (是否有效, 错误消息)
        """
        required_options = []  # 必需的选项
        
        for option in required_options:
            if option not in options:
                return False, f"缺少必需选项: {option}"
                
        return True, None

# 插件入口函数
def main():
    return ActionPlugin()
`
                },
                'tagSource-js': {
                    name: 'tag_source_plugin_template',
                    content: `/**
 * Name: 标签源插件模板
 * Description: 这是一个标签源插件的模板文件
 * Version: 1.0.0
 * Type: tagSource
 * ID: tag_source_template_js
 * Author: Your Name
 */

class TagSourcePlugin {
    constructor() {
        this.name = "标签源插件模板";
        this.version = "1.0.0";
        this.description = "这是一个标签源插件的模板";
    }

    /**
     * 搜索音乐标签信息
     * @param {Object} query - 搜索查询参数
     * @param {string} query.title - 歌曲标题
     * @param {string} query.artist - 艺术家
     * @param {string} query.album - 专辑名
     * @returns {Array} 搜索结果列表
     */
    async search(query) {
        try {
            // 实现你的搜索逻辑
            const results = [];
            
            // 示例返回格式
            const result = {
                title: query.title || '',
                artist: query.artist || '',
                album: query.album || '',
                year: null,
                genre: null,
                track_number: null,
                disc_number: null,
                lyrics: null,
                cover_url: null,
                confidence: 0.0  // 匹配置信度 0-1
            };
            
            results.push(result);
            return results;
            
        } catch (error) {
            console.error('搜索失败:', error);
            return [];
        }
    }

    /**
     * 获取歌词
     * @param {string} title - 歌曲标题
     * @param {string} artist - 艺术家
     * @returns {string|null} 歌词内容
     */
    async getLyrics(title, artist) {
        try {
            // 实现歌词获取逻辑
            return null;
        } catch (error) {
            console.error('获取歌词失败:', error);
            return null;
        }
    }

    /**
     * 获取专辑封面
     * @param {string} title - 歌曲标题
     * @param {string} artist - 艺术家
     * @param {string} album - 专辑名
     * @returns {string|null} 封面图片URL
     */
    async getCover(title, artist, album) {
        try {
            // 实现封面获取逻辑
            return null;
        } catch (error) {
            console.error('获取封面失败:', error);
            return null;
        }
    }
}

// 插件入口函数
function main() {
    return new TagSourcePlugin();
}

// 如果在Node.js环境中
if (typeof module !== 'undefined' && module.exports) {
    module.exports = main;
}
`
                },
                'action-js': {
                    name: 'action_plugin_template',
                    content: `/**
 * Name: 操作台插件模板
 * Description: 这是一个操作台插件的模板文件
 * Version: 1.0.0
 * Type: action
 * ID: action_template_js
 * Author: Your Name
 */

const fs = require('fs');
const path = require('path');

class ActionPlugin {
    constructor() {
        this.name = "操作台插件模板";
        this.version = "1.0.0";
        this.description = "这是一个操作台插件的模板";
    }

    /**
     * 执行插件操作
     * @param {Array} files - 要处理的文件列表
     * @param {Object} options - 插件选项参数
     * @returns {Object} 执行结果
     */
    async execute(files, options = {}) {
        let processed = 0;
        const errors = [];

        try {
            for (const filePath of files) {
                if (fs.existsSync(filePath)) {
                    const result = await this.processFile(filePath, options);
                    if (result) {
                        processed++;
                    } else {
                        errors.push(\`处理文件失败: \${filePath}\`);
                    }
                } else {
                    errors.push(\`文件不存在: \${filePath}\`);
                }
            }

            return {
                success: errors.length === 0,
                message: \`处理完成，成功: \${processed}, 失败: \${errors.length}\`,
                processed: processed,
                errors: errors
            };

        } catch (error) {
            return {
                success: false,
                message: \`执行失败: \${error.message}\`,
                processed: processed,
                errors: errors.concat([error.message])
            };
        }
    }

    /**
     * 处理单个文件
     * @param {string} filePath - 文件路径
     * @param {Object} options - 处理选项
     * @returns {boolean} 是否处理成功
     */
    async processFile(filePath, options) {
        try {
            console.log(\`处理文件: \${filePath}\`);

            // 示例：重命名文件
            if (options.rename) {
                const newName = options.new_name || 'new_file';
                // 重命名逻辑
            }

            // 示例：修改文件元数据
            if (options.update_metadata) {
                // 元数据修改逻辑
            }

            return true;

        } catch (error) {
            console.error(\`处理文件失败: \${filePath}, 错误: \${error.message}\`);
            return false;
        }
    }

    /**
     * 验证插件选项
     * @param {Object} options - 选项参数
     * @returns {Array} [是否有效, 错误消息]
     */
    validateOptions(options) {
        const requiredOptions = []; // 必需的选项

        for (const option of requiredOptions) {
            if (!(option in options)) {
                return [false, \`缺少必需选项: \${option}\`];
            }
        }

        return [true, null];
    }
}

// 插件入口函数
function main() {
    return new ActionPlugin();
}

// 如果在Node.js环境中
if (typeof module !== 'undefined' && module.exports) {
    module.exports = main;
}
`
                }
            };

            const templateKey = `${type}-${extension}`;
            const template = templates[templateKey];

            if (!template) {
                this.$myMsg.notify({
                    title: '模板不存在',
                    message: `未找到 ${type} 类型的 ${extension} 模板`,
                    type: 'error',
                    time: 3000
                });
                return;
            }

            // 创建下载
            const blob = new Blob([template.content], { type: 'text/plain;charset=utf-8' });
            const url = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = `${template.name}.${extension}`;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            URL.revokeObjectURL(url);

            this.$myMsg.notify({
                title: '模板下载成功',
                message: `已下载 ${template.name}.${extension}`,
                type: 'success',
                time: 2000
            });
        }
    }
}
</script>

<style scoped>
.line-clamp-2 {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
}

.h-screen-header {
    height: calc(100vh - 4rem);
}
</style>
